import { useEffect } from 'react';
var CalendlyEvent = {
  PROFILE_PAGE_VIEWED: 'calendly.profile_page_viewed',
  EVENT_TYPE_VIEWED: 'calendly.event_type_viewed',
  DATE_AND_TIME_SELECTED: 'calendly.date_and_time_selected',
  EVENT_SCHEDULED: 'calendly.event_scheduled'
};
var EVENT_NAME = 'message';
export default function useCalendlyEventListener() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onDateAndTimeSelected = _ref.onDateAndTimeSelected,
    onEventScheduled = _ref.onEventScheduled,
    onEventTypeViewed = _ref.onEventTypeViewed,
    onProfilePageViewed = _ref.onProfilePageViewed;
  var eventHandlers = {
    onDateAndTimeSelected: onDateAndTimeSelected,
    onEventScheduled: onEventScheduled,
    onEventTypeViewed: onEventTypeViewed,
    onProfilePageViewed: onProfilePageViewed
  };
  useEffect(function () {
    var onMessage = function onMessage(messageEvent) {
      var eventName = messageEvent.data.event;
      if (eventName === CalendlyEvent.DATE_AND_TIME_SELECTED) {
        if (onDateAndTimeSelected) onDateAndTimeSelected(messageEvent);
      } else if (eventName === CalendlyEvent.EVENT_SCHEDULED) {
        if (onEventScheduled) onEventScheduled(messageEvent);
      } else if (eventName === CalendlyEvent.EVENT_TYPE_VIEWED) {
        if (onEventTypeViewed) onEventTypeViewed(messageEvent);
      } else if (eventName === CalendlyEvent.PROFILE_PAGE_VIEWED) {
        if (onProfilePageViewed) onProfilePageViewed(messageEvent);
      }
    };
    window.addEventListener(EVENT_NAME, onMessage);
    return function cleanup() {
      window.removeEventListener(EVENT_NAME, onMessage);
    };
  }, [eventHandlers]);
}